import type { ISVG } from './index';

export const SituationRoomSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill='none'
	>
		<path
			d='M4 4h16a2 2 0 012 2v8a2 2 0 01-2 2h-6l-2 3-2-3H4a2 2 0 01-2-2V6a2 2 0 012-2z'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
			fill='none'
		/>
		<path
			d='M12 7v4M12 13h.01'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
		/>
		<circle
			cx='8'
			cy='10'
			r='1'
			fill={color || 'currentColor'}
		/>
		<circle
			cx='16'
			cy='10'
			r='1'
			fill={color || 'currentColor'}
		/>
	</svg>
);
